import React from 'react';
import "../styles/WhatsAppChat.css";
import whatsAppIcon from '../assets/images/social-icons/whatsapp-icon-noBackground.png';

export default function WhatsAppChat() {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hello, I would like to enquire about SAHPRA licensing."
    );
    window.open(`https://wa.me/27645406751?text=${message}`, "_blank");
  };
 
  return (
    <div className="whatsapp-chat">
      <button onClick={handleWhatsAppClick} aria-label="Chat with us on WhatsApp">
        <img src={whatsAppIcon} alt="WhatsApp" />
        <span className="notif-dot" />
      </button>
    </div>
  );
}